import { shortenText } from "../../global/utilities/StringLengthLimiter";
import { useResolutionsContext } from "../hooks/useResolutionsContext";
import { IResolution } from "../types/interfaces/IResolution";
import { IResolutionsSelectProps } from "../types/interfaces/IResolutionsSelectProps";
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';

//This component is responsible for rendering the resolutions select dropdown.
//Props: The IResolutionEvent object and onSelectResolution function are passed in from the caller.
const ResolutionsSelect: React.FC<IResolutionsSelectProps> = ({ onSelectResolution }) => {
    const {selectedEvent} = useResolutionsContext();
    
    //Function to handle a resolution selection.
    const resolutionChange = (value: string) => {
        const resolutionNumber = Number(value);
        const resolution: IResolution = selectedEvent?.Resolutions.find((resolution: IResolution) => resolution.Number === resolutionNumber);
        onSelectResolution(resolution);
    };

    return (
        <Box sx={{ paddingBottom: 1 }}>
            <Typography variant="h6" component="div" color="primary.dark" sx={{ paddingTop: 2 }}>
                <Box sx={{ fontWeight: "bold" }}>Resolution</Box>
            </Typography>
            <FormControl sx={{ width: "60%" }}>
                <InputLabel id="labelSelectResolution" style={{ marginLeft: 10, top: "50%", transform: "translate(0,-50%)" }} sx={{ fontSize: "18px" }}>Select a Resolution</InputLabel>
                <Select id="selectResolutionChange" value="" onChange={(e) => resolutionChange(e.target.value)} sx={{ maxHeight: 30 }}>
                    <MenuItem value="Select"><em>Select</em></MenuItem>
                    {selectedEvent?.Resolutions.map((resolution: IResolution) => (
                        <MenuItem key={resolution.Number} value={resolution.Number}>
                            {resolution.Number}. {shortenText(resolution.Name, 100)}
                        </MenuItem>           
                    ))}
                </Select>
            </FormControl>
        </ Box>
    );
}

export default ResolutionsSelect;